import { ActionTypes } from './constants';
import * as Models from './models';

export const setBrandDefinition: Models.ActionCreator.SetBrandDefinition = brandDefinition => ({
  type: ActionTypes.SET_BRAND_DEFINITION,
  payload: {
    brandDefinition,
  },
});
